import {Product} from "@app/core/product/domain/dtos/product";
import {PromotionDetail} from "@app/core/promotion/domain/dtos/promotion-detail";
import {CartLine} from "../../domain/dtos/cart-line";

export class CartLineMapper {

    static deserialize(param: any): CartLine {
        return {
            code: param.code,
            name: param.name,
            image: param.image_small,
            price: param.price,
            units: param.units,
            unitPrice: param.unit_price,
            quantity: param.quantity,
            promotionCode: "",
            palletPrice: param.paletPrice ?? 0,
        }
    }

    static serialize(param: CartLine): any {
        return {
            code: param.code,
            name: param.name,
            image_small: param.image,
            price: param.price,
            total_price: Number((param.price * param.quantity).toFixed(2)),
            units: param.units,
            unit_price: param.unitPrice,
            quantity: param.quantity,
        }
    }

    static fromProductToCartLine(product: Product, quantity: number, promotionCode?: string | null): CartLine {
        return {
            code: product.code,
            name: product.name,
            image: product.image,
            price: product.price,
            units: product.units,
            unitPrice: product.unitPrice,
            quantity: quantity,
            promotionCode: promotionCode ?? "",
            palletPrice: product.palletPrice ?? 0,
        } as CartLine
    }

    static fromPromotionToCartLines(promotion: PromotionDetail): CartLine[] {
        const cartLines: CartLine[] = [];

        promotion.details.forEach(item => {
            const cartLine = CartLineMapper.fromProductToCartLine(item, item.quantity);
            cartLine.promotionCode = promotion.code;
            cartLines.push(cartLine);
        });
        return cartLines;
    }
}
